import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { E_CONSENT_PARTY_TYPE_OPTIONS, EConsentPartyType, TableCellId } from './Consent.constants';

const formatConsentDate = date => (date ? dayjs(date).format(COMMON_DATETIME_FORMAT) : 'N/A');

const getPartyLabel = partyType =>
  E_CONSENT_PARTY_TYPE_OPTIONS.find(option => option.value === partyType)?.name || '';

export const mapConsentRecordsToTableData = ({ records, creditConsentDate }) =>
  records.map(record => {
    const isPrimaryBorrower = record.partyType === EConsentPartyType.PRIMARY_BORROWER;

    return {
      [TableCellId.FULL_NAME]: record.fullName,
      [TableCellId.PARTY]: getPartyLabel(record.partyType),
      [TableCellId.E_CONSENT]: formatConsentDate(record.eConsentDate),
      [TableCellId.CREDIT_CONSENT]: isPrimaryBorrower
        ? formatConsentDate(creditConsentDate)
        : 'N/A',
    };
  });
